import { CheckCircle, Cancel, HourglassEmpty, Info } from "@mui/icons-material";
import { green, blue, orange, grey, red, common } from "@mui/material/colors";
import { TransactionStatus } from "Infrastructure/Api/Api";
import type { ReactNode } from "react";
import type { TFunction } from "Translations/Resources";
import { Resources } from "Translations/Resources";
import { MS_TIME } from "Utils/TimeUtils";

const STATUS_RESOURCES = Resources.Chat.TransactionStatus;
const ICON_SX = { color: common.white, fontSize: 20 } as const;

export type StatusVariant = {
  cardBackground: string;
  statusBackground: string;
  statusColor: string;
  labelKey: (t: TFunction) => string;
  icon: ReactNode;
};

export const statusVariants: Record<string, StatusVariant> = {
  [TransactionStatus.Success]: {
    cardBackground: green[50],
    statusBackground: green[400],
    statusColor: common.white,
    labelKey: (t) => t(STATUS_RESOURCES.Success),
    icon: <CheckCircle sx={ICON_SX} />,
  },
  [TransactionStatus.Processing]: {
    cardBackground: blue[50],
    statusBackground: blue[400],
    statusColor: common.white,
    labelKey: (t) => t(STATUS_RESOURCES.Processing),
    icon: <HourglassEmpty sx={ICON_SX} />,
  },
  [TransactionStatus.Initiated]: {
    cardBackground: orange[50],
    statusBackground: orange[400],
    statusColor: common.white,
    labelKey: (t) => t(STATUS_RESOURCES.Initiated),
    icon: <HourglassEmpty sx={ICON_SX} />,
  },
  [TransactionStatus.Created]: {
    cardBackground: grey[100],
    statusBackground: grey[400],
    statusColor: common.white,
    labelKey: (t) => t(STATUS_RESOURCES.Created),
    icon: <Info sx={ICON_SX} />,
  },
  [TransactionStatus.Fail]: {
    cardBackground: red[50],
    statusBackground: red[400],
    statusColor: common.white,
    labelKey: (t) => t(STATUS_RESOURCES.Fail),
    icon: <Cancel sx={ICON_SX} />,
  },
  [TransactionStatus.Cancelled]: {
    cardBackground: grey[50],
    statusBackground: grey[500],
    statusColor: common.white,
    labelKey: (t) => t(STATUS_RESOURCES.Cancelled),
    icon: <Cancel sx={ICON_SX} />,
  },
};

export const defaultVariant: StatusVariant = {
  cardBackground: grey[100],
  statusBackground: grey[400],
  statusColor: common.white,
  labelKey: (t) => t(STATUS_RESOURCES.Unknown),
  icon: <Info sx={ICON_SX} />,
};

export const terminalStatuses: Array<string> = [
  TransactionStatus.Success,
  TransactionStatus.Fail,
  TransactionStatus.Cancelled,
];

export const POLL_INTERVAL_MS = 10 * MS_TIME.second;
